import DevisListContent from '@/components/devis/devis-list-content';
import useGetAvatar from '@/hooks/useGetAvatar';
import { composeUri } from '@/utils/compose';
import { AVATAR_GROUP_QUOTE_TYPE, AVATARS, PLACES, ROLE_BIG_READ_QUOTE } from '@/utils/CONST';
import { useAuthenticated, usePermissions } from 'react-admin';
import { useParams } from 'react-router';

const DevisList = () => {
    useAuthenticated();

    const { placeId, siteId } = useParams();
    const { permissions } = usePermissions();

    const { avatar, isLoading: isLoadingPlace } = useGetAvatar({
        avatarUriId: placeId != null ? composeUri(AVATARS, placeId) : undefined,
        queryKey: `${PLACES}_${siteId ?? ''}`,
    });

    const placeAlphaId = avatar?.alphaId;

    const filter = {
        type: AVATAR_GROUP_QUOTE_TYPE,
        ...(placeAlphaId != null ? { identifiers: [placeAlphaId] } : {}),
    };

    const queryEnabled = permissions?.includes(ROLE_BIG_READ_QUOTE) && !isLoadingPlace && placeAlphaId != null;

    return <DevisListContent filter={filter} queryEnabled={queryEnabled} loading={isLoadingPlace} />;
};

export default DevisList;
